import React, { useEffect, useState } from "react";
import { api } from "../api";
import Modal from "../components/Modal";

const EMPTY = { name: "", address: "", is_partner: false };

export default function Locations() {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [error, setError] = useState(null);

  const reload = () => {
    setLoading(true);
    api.listLocations().then(setLocations).finally(() => setLoading(false));
  };

  useEffect(reload, []);

  const onSave = async (l) => {
    setError(null);
    try {
      if (l.id) await api.updateLocation(l.id, l);
      else await api.createLocation(l);
      setModal(null);
      reload();
    } catch (err) {
      setError(err.message);
    }
  };

  const onDelete = async (id) => {
    if (!window.confirm("Standort löschen?")) return;
    try {
      await api.deleteLocation(id);
      reload();
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <h1 className="text-2xl">Standorte</h1>
          <p className="text-fh-gray text-sm mt-1">{locations.length} Standorte</p>
        </div>
        <button onClick={() => setModal(EMPTY)} className="btn-primary">+ Neuer Standort</button>
      </div>

      <div className="card overflow-hidden">
        {loading ? (
          <div className="p-8 text-center text-fh-gray">Lade…</div>
        ) : locations.length === 0 ? (
          <div className="p-8 text-center text-fh-gray">Keine Standorte.</div>
        ) : (
          <ul className="divide-y divide-gray-100">
            {locations.map((l) => (
              <li key={l.id} className="px-5 py-3 flex items-center justify-between">
                <div>
                  <div className="font-medium">
                    {l.name}
                    {l.is_partner && <span className="badge bg-blue-50 text-blue-800 ml-2">Partner</span>}
                  </div>
                  <div className="text-xs text-fh-gray">{l.address || "—"} · {l.id}</div>
                </div>
                <div className="flex gap-2">
                  <button onClick={() => setModal(l)} className="btn-ghost text-sm">Bearbeiten</button>
                  <button onClick={() => onDelete(l.id)} className="btn-ghost text-sm text-fh-red">Löschen</button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>

      {modal && (
        <Modal
          open
          title={modal.id ? "Standort bearbeiten" : "Neuer Standort"}
          onClose={() => { setModal(null); setError(null); }}
          footer={
            <>
              <button className="btn-secondary" onClick={() => { setModal(null); setError(null); }}>Abbrechen</button>
              <button className="btn-primary" onClick={() => onSave(modal)} disabled={!modal.name.trim()}>Speichern</button>
            </>
          }
        >
          {error && <div className="bg-fh-red/10 text-fh-red-dark text-sm px-3 py-2 rounded mb-3">{error}</div>}
          <div className="space-y-3">
            <div>
              <label className="label-field">Name *</label>
              <input className="input-field" value={modal.name} onChange={(e) => setModal({ ...modal, name: e.target.value })} />
            </div>
            <div>
              <label className="label-field">Adresse</label>
              <input className="input-field" value={modal.address || ""} onChange={(e) => setModal({ ...modal, address: e.target.value })} />
            </div>
            <label className="flex items-center gap-2 text-sm">
              <input
                type="checkbox"
                className="h-4 w-4 accent-fh-red"
                checked={modal.is_partner}
                onChange={(e) => setModal({ ...modal, is_partner: e.target.checked })}
              />
              <span>Partner-Standort (Material wird zur Verfügung gestellt)</span>
            </label>
          </div>
        </Modal>
      )}
    </div>
  );
}
